import Experiment, { useBucket } from '@mc/experiments-react'
import { TrackingContainer } from '@mc/visibility'
import { useStaticData } from '@mc/static-data-react'

import { DROPPABLE_QUIZ_MODULE_EXPERIMENT_NAME } from './constants'
import { DroppableQuizVariant1 } from './DroppableQuizVariant1'
import { trackDroppableQuizModuleViewed } from './events'

export const DroppableQuizModuleExperiment = () => {
  const bucket = useBucket(DROPPABLE_QUIZ_MODULE_EXPERIMENT_NAME)
  const { ctaNextPage } = useStaticData<{ ctaNextPage?: string }>()
  const isQuizCompleted = !!ctaNextPage

  if (isQuizCompleted) return <></>

  const trackModuleViewed = () => {
    if (bucket?.includes('variant')) {
      trackDroppableQuizModuleViewed()
    }
  }

  return (
    <TrackingContainer
      onFirstVisible={trackModuleViewed}
      config={{ threshold: 0.01 }}
    >
      <Experiment
        name={DROPPABLE_QUIZ_MODULE_EXPERIMENT_NAME}
        variant_1={() => <DroppableQuizVariant1 />}
      />
    </TrackingContainer>
  )
}
